<template>
    <FontAwesomeIcon data-test="icon" :icon="name" :size="size" />
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library, config } from '@fortawesome/fontawesome-svg-core';
import * as allIcons from '@fortawesome/free-solid-svg-icons';

config.autoAddCss = false;

export default {
  name: 'FontIcon',
  components: {
    FontAwesomeIcon,
  },
  beforeMount() {
    library.add(allIcons[this.importName]);
  },
  computed: {
    importName() {
      const camelCase = this.name.replace(/-./g, x => x[1].toUpperCase());
      return `fa${camelCase.charAt(0).toUpperCase()}${camelCase.substr(1)}`;
    },
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
    },
  },
};
</script>
